import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const Operation = lazy(() => import('@/pages/operation'));
const NewsList = lazy(() => import('@/pages/operation/news/NewsList'));
const NewsDetail = lazy(() => import('@/pages/operation/news/NewsDetail'));
const InstagramList = lazy(() => import('@pages/operation/instagram/InstagramList'));
const InstagramDetail = lazy(() => import('@pages/operation/instagram/InstagramDetail'));
const YoutubeList = lazy(() => import('@pages/operation/youtube/YoutubeList'));
const YoutubeDetail = lazy(() => import('@pages/operation/youtube/YoutubeDetail'));
const PrivacyPolicyList = lazy(() => import('@pages/operation/privacyPolicy/PrivacyPolicyList'));
const PrivacyPolicyDetail = lazy(() => import('@pages/operation/privacyPolicy/PrivacyPolicyDetail'));
const TermsOfServiceList = lazy(() => import('@pages/operation/termsOfService/TermsOfServiceList'));
const TermsOfServiceDetail = lazy(() => import('@pages/operation/termsOfService/TermsOfServiceDetail'));

export const operationRoutes: TypedRouteObject = {
	path: ROOTS.OPERATION,
	element: withSuspense(Operation),
	handle: {
		title: '콘텐츠',
		subTitle: '글로벌·국내 홈페이지 콘텐츠 관리',
	},
	children: [
		{
			index: true,
			element: <Navigate to={paths.operation.news.list.path} replace />,
		},
		// 뉴스 관리
		{
			path: paths.operation.news.list.path,
			element: withSuspense(NewsList),
			handle: {
				title: '콘텐츠',
				subTitle: '글로벌·국내 홈페이지 콘텐츠 관리',
			},
		},
		{
			path: paths.operation.news.detail.path,
			element: withSuspense(NewsDetail),
			handle: {
				isGoBack: true,
				title: '콘텐츠',
				subTitle: '콘텐츠 > 뉴스 > 상세 정보',
			},
		},
		// 인스타그램 관리
		{
			path: paths.operation.instagram.list.path,
			element: withSuspense(InstagramList),
			handle: {
				title: '콘텐츠',
				subTitle: '글로벌·국내 홈페이지 콘텐츠 관리',
			},
		},
		{
			path: paths.operation.instagram.detail.path,
			element: withSuspense(InstagramDetail),
			handle: {
				isGoBack: true,
				title: '콘텐츠',
				subTitle: '콘텐츠 > 인스타그램 > 상세정보',
			},
		},
		// 유튜브 관리
		{
			path: paths.operation.youtube.list.path,
			element: withSuspense(YoutubeList),
			handle: {
				title: '콘텐츠',
				subTitle: '글로벌·국내 홈페이지 콘텐츠 관리',
			},
		},
		{
			path: paths.operation.youtube.detail.path,
			element: withSuspense(YoutubeDetail),
			handle: {
				isGoBack: true,
				title: '콘텐츠',
				subTitle: '콘텐츠 > 유튜브 > 상세정보',
			},
		},
		// 개인정보 처리방침
		{
			path: paths.operation.privacyPolicy.list.path,
			element: withSuspense(PrivacyPolicyList),
			handle: {
				title: '콘텐츠',
				subTitle: '개인정보 처리방침 관리',
			},
		},
		{
			path: paths.operation.privacyPolicy.detail.path,
			element: withSuspense(PrivacyPolicyDetail),
			handle: {
				isGoBack: true,
				title: '콘텐츠',
				subTitle: '콘텐츠 > 개인정보 처리방침 > 상세정보',
			},
		},
		// 이용약관
		{
			path: paths.operation.termsOfService.list.path,
			element: withSuspense(TermsOfServiceList),
			handle: {
				title: '콘텐츠',
				subTitle: '이용약관 관리',
			},
		},
		{
			path: paths.operation.termsOfService.detail.path,
			element: withSuspense(TermsOfServiceDetail),
			handle: {
				isGoBack: true,
				title: '콘텐츠',
				subTitle: '콘텐츠 > 이용약관 > 상세정보',
			},
		},
	],
};
